<!-- @format -->

<template>
	<div>
		<el-button @click="onClick"> 编写代码 </el-button>
		<pc-dialog v-model="aceStatus.disabled" :title="pcProps.label" @on-confirm="onSave" @on-cancel="onCancel">
			<script-area v-model="aceStatus.value" />
		</pc-dialog>
	</div>
</template>
<script setup lang="ts">
	import ScriptList from '../../utils/script';
	import { type WidgetConfigType } from '../../types';
	import ScriptArea from './script-area.vue';
	import { PcDialog } from '@/components';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const scriptConfig = inject<ScriptList>('scriptConfig');

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const aceStatus = ref({
		disabled: false,
		value: '',
	});

	const onClick = () => {
		aceStatus.value = {
			disabled: true,
			value: value.value.toString(),
		};
	};

	const onCancel = (callback?: Function) => {
		callback && callback();
		aceStatus.value = {
			disabled: false,
			value: '',
		};
	};

	const onSave = (callback) => {
		callback();
		if (scriptConfig!.pickEvalStr(aceStatus.value.value.toString())) {
			value.value = aceStatus.value.value.toString();
			onCancel();
		}
	};
</script>
<style lang="scss" scoped>
	.ace-editor {
		min-height: 300px;
	}

	.script-template {
		font-size: 12px;
		padding: 5px;
		background-color: #ebebeb;
	}
</style>
